import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { LimitContext } from '../contexts/LimitContext';
import MediaGalleryActions from '../components/MediaGalleryActions';
import useMutation from '../../modules/react/hooks/useMutation';

export const SOFT_DELETE_MEDIUM = gql`
  mutation MediumSoftDelete($id: ID!, $trash: Boolean!) {
    mediumToggleTrash(id: $id, trash: $trash) {
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  selectedMedium: PropTypes.string.isRequired,
  setSelectedMedium: PropTypes.func.isRequired,
  setBanners: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
};

const defaultProps = {};

const MediaGalleryActionsContainer = ({
  selectedMedium,
  setSelectedMedium,
  setBanners,
  updateFilter,
  filter,
}) => {
  const [deleteImage, { data, loading }] = useMutation(SOFT_DELETE_MEDIUM);
  const [limit, setLimit] = useContext(LimitContext);

  const onConfirmDelete = async () => {
    await deleteImage({ variables: { id: selectedMedium, trash: true } });
    setLimit(limit - 1);
  };

  return (
    <MediaGalleryActions
      softDeleteMedium={onConfirmDelete}
      loading={loading}
      data={data}
      setSelectedMedium={setSelectedMedium}
      setBanners={setBanners}
      updateFilter={updateFilter}
      filter={filter}
    />
  );
};

MediaGalleryActionsContainer.propTypes = propTypes;
MediaGalleryActionsContainer.defaultProps = defaultProps;

export default MediaGalleryActionsContainer;
